<template>
    <ul class="shop-navigation">
        <router-link v-for="(link, key) in links" :key="key" :to="link" v-slot="{ href, route, navigate, isExactActive }">
            <li :class="[isExactActive && 'active', 'shop-navigation-item']">
                <a :href="href" @click="navigate" v-text="route.name"></a>
            </li>
        </router-link>
    </ul>
</template>
<script>
import { pageRoute } from "@utils/network";

export default {
    name: "ShopSidebar",

    computed: {
        links() {
            return this.$store.getters.isAuthenticated ? [
                pageRoute("/shops/:id/about", { id: this.shop.id }, false),
                pageRoute("/shops/:id/services", { id: this.shop.id }, false),
                pageRoute("/shops/:id/schedueles", { id: this.shop.id }, false),
                pageRoute("/shops/:id/experts", { id: this.shop.id }, false),
                // pageRoute("/shops/:id/gallery", { id: this.shop.id }, false),
                pageRoute("/shops/:id/vouchers", { id: this.shop.id }, false),
            ] : this.unauthenticatedLinks;
        },
        unauthenticatedLinks() {
            return [
                pageRoute("/shops/:id/about", { id: this.shop.id }, false),
                pageRoute("/shops/:id/services", { id: this.shop.id }, false),
                pageRoute("/shops/:id/schedueles", { id: this.shop.id }, false),
                pageRoute("/shops/:id/experts", { id: this.shop.id }, false),
            ]
        },
    },

    props: {
        shop: Object
    }
}
</script>
<style lang="css" scoped>
    .shop-navigation {
        list-style: none;
        padding: 70px 0 0 0;
    }
    .shop-navigation-item {
        padding: 10px 7.5px;
    }
    .shop-navigation-item a {
        color: #555555;
    }
    .shop-navigation-item a:hover {
        color: #EE4036;
    }
    .shop-navigation-item.active a {
        color: #EE4036;
    }
</style>